import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AppUtils } from '../../utlis/app-utils';
import { OneWebComponentsAngularModule } from '@one/angular';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-view-reminder-details',
  standalone: true,
  imports: [OneWebComponentsAngularModule,CommonModule],
  templateUrl: './view-reminder-details.component.html',
  styleUrls: ['./view-reminder-details.component.scss']
})
export class ViewReminderDetailsComponent implements OnChanges {
  @Input() data: any;
 @Output() close = new EventEmitter<void>();
  public displayedColumns = [
    'ReminderSubject',
    'ReminderSendDate',
    'ReminderDueDate',
    'ReminderSendStatus',
    'expandTrigger'
  ];

  public dataSource: any[] = [];
  public tableData: any[] = [];
  public expandedElement: any;

  constructor(public appUtils: AppUtils, private router: Router) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data) {
      const notificationData = this.data.notificationData;
      const customerData = this.data.customerData;

      const notificationReminderData = notificationData?.NotificationReminders || [];
      const customerReminderData = customerData?.CustomerReminderDetails || [];

      // merge customer + notification reminders
      this.tableData = customerReminderData.map(item => {
        const reminderItem = notificationReminderData.find(
          reItem => reItem.ReminderId === item.ReminderId
        );
        return { ...reminderItem, ...item };
      });

      this.dataSource = this.tableData;
     
    }
  }

  public displayStatus(status: string): string {
    if (status === 'Not Sent') return 'Scheduled';
    if (status === 'Delivered') return 'Sent';
    return status;
  }

  public getLastReminderSent(): string {
    const allSentData = this.tableData.filter(item => item.ReminderSendStatus === 'Delivered');
    const allFailedData = this.tableData.filter(item => item.ReminderSendStatus === 'Delivery Failed');

    if (allSentData.length > 0) {
      return this.appUtils.formatDateWithTime(
        allSentData[allSentData.length - 1].ReminderSendDate
      );
    } else if (allFailedData.length > 0) {
      return this.appUtils.formatDateWithTime(
        allFailedData[allFailedData.length - 1].ReminderDeliveryFailedDate
      );
    }
    return '';
  }

  public expandDetails(element: any) {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  public expandToggle(element: any) {
    this.expandedElement =
      this.expandedElement !== element && !element.disabled ? element : null;
  }

  public isExpanded(row: any): boolean {
    return row === this.expandedElement;
  }

   onCloseClick() {
    this.close.emit();
  }
}
